export default function Stats() {
  const stats = [
    {
      icon: 'ri-arrow-up-line',
      number: '12,450+',
      label: 'Items Swapped'
    },
    {
      icon: 'ri-group-line',
      number: '8,200+',
      label: 'Active Members'
    },
    {
      icon: 'ri-leaf-line',
      number: '3.2M kg',
      label: 'CO₂ Saved'
    }
  ];

  return (
    <div className="relative -mt-20 z-20">
      <div className="max-w-6xl mx-auto px-6">
        <div className="bg-white/95 backdrop-blur-sm rounded-3xl shadow-2xl p-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="flex items-center justify-center mb-3">
                  <i className={`${stat.icon} text-3xl text-teal-600`}></i>
                </div>
                <div className="text-4xl font-bold text-gray-900 mb-1">{stat.number}</div>
                <div className="text-sm text-gray-600 font-medium">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
